import React, { Component } from 'react'

import { withRouter, Link } from "react-router-dom";
import { Container, Nav, Navbar, NavDropdown, Image } from 'react-bootstrap'
import Notification from '../../../navbars/Notification';
import ChangePassword from '../../../navbars/ChangePassword';
import BrandLogo from '../../../navbars/BrandLogo';
import * as Cookies from "es-cookie";
import * as compose from 'lodash.flowright';
import { brandLoginUrl } from "../../../../../utils/brandLogin";
class VideoNavbar extends Component {
    constructor(props) {
        super(props)
        this.state = {
            modalShow: false
        }
    }
    logout = () => {
        if (Cookies.get("studenttoken") !== undefined) {
            Cookies.remove("studenttoken");
            Cookies.remove("studentrefreshtoken");
            Cookies.remove("studentusername");
            Cookies.remove("studentemail");

            Cookies.remove("mobile");
            Cookies.remove("classid");
            Cookies.remove("examid");
            Cookies.remove("exam_name");
            Cookies.remove("mobileverified");
            Cookies.remove("targetyear");
            Cookies.remove("videos");
            Cookies.remove("branch_name");
            Cookies.remove("role", "");
            Cookies.remove("profile_pic");
            Cookies.remove("student_userlevel");
            Cookies.remove("stulogintype", "");
            const institutionId119 = Cookies.get("institution_id");
            Cookies.remove("institution_id");
            localStorage.removeItem('profile_pic');
            localStorage.removeItem('studentglobals');
            localStorage.removeItem('globalsubjects');
            if (brandLoginUrl(institutionId119)) {
                window.location.href = brandLoginUrl(institutionId119);
            } else {
                this.props.history.push("/student/login");
            }
        }
    };
    render() {
        
        let isuserValid = "";
        
        if (this.props.urltype != "default" && this.props.urltype != "fdefaultvideo") {
            console.log("videonavbar",this.props.urltype);
            let isStudentUserValid = "";
            if (JSON.parse(localStorage.getItem("isStudentUserValid")) != "") {
                isStudentUserValid = JSON.parse(localStorage.getItem("isStudentUserValid"));
            }
            else {
                this.props.history.push("/student/login");
            }
            isuserValid = JSON.parse(
                isStudentUserValid.user_access_restictions
            );

            
        }
        //console.log("mname", this.props.mname);
        return (
            <Navbar className="header-top navbar navbar-expand-md navbar-dark bg-dark">
                <Container>
                    {this.props.getChapterId.type != "iv" ? (
                        <React.Fragment>
                            {this.props.getChapterId.ComponentParams.pagetype == "chlistpath" ? (
                                <Link
                                    to={{
                                        pathname: "/student/subject/start-watching",
                                        state: {
                                            otid: "0",
                                            ocid: "0",
                                            subjectid: this.props.getChapterId.getChapterId.subjectid,
                                        }
                                    }}
                                    className="my-0 font-weight-normal text-light mr-auto">
                                    <i className="fal fa-arrow-left" />
                                </Link>
                            )
                                : this.props.getChapterId.ComponentParams.pagetype == "topiclistpath" ? (
                                    <Link
                                        to={{
                                            pathname: "/student/subject/start-watching",
                                            state: {
                                                otid: "0",
                                                ocid: this.props.getChapterId.getChapterId.ocid,
                                                subjectid: this.props.getChapterId.getChapterId.subjectid,
                                            }
                                        }}
                                        className="my-0 font-weight-normal text-light mr-auto">
                                        <i className="fal fa-arrow-left" />
                                    </Link>
                                )
                                    : (
                                        <Link
                                            to={{
                                                pathname: "/student/subject/start-learning",
                                                state: {
                                                    ocid: this.props.getChapterId.getChapterId.ocid,
                                                    otid: this.props.getChapterId.getChapterId.otid,
                                                    subjectid: this.props.getChapterId.getChapterId.subjectid,
                                                    defaultActiveKey: "third"
                                                },
                                            }}
                                            className="my-0 font-weight-normal text-light mr-auto">
                                            <i className="fal fa-arrow-left" />
                                        </Link>
                                    )}
                        </React.Fragment>
                    ) : (
                            <React.Fragment>
                                {this.props.mname == "feartured" ? (
                                    <React.Fragment>
                                        {this.props.urltype == "default" ? (
                                            <Link
                                                to={{
                                                    pathname: "/student/default-videos",
                                                }}
                                                className="my-0 font-weight-normal text-light mr-auto">
                                                <i className="fal fa-arrow-left" />
                                            </Link>
                                        ) 
                                        : this.props.urltype == "fdefaultvideo"?(
                                            <Link
                                                to={{
                                                    pathname: "/student/default-featured-videos",
                                                }}
                                                className="my-0 font-weight-normal text-light mr-auto">
                                                <i className="fal fa-arrow-left" />
                                            </Link>
                                        ): (
                                                <Link
                                                    to={{
                                                        pathname: "/student/featuredvideos",
                                                    }}
                                                    className="my-0 font-weight-normal text-light mr-auto">
                                                    <i className="fal fa-arrow-left" />
                                                </Link>
                                            )}
                                    </React.Fragment>
                                ) : (
                                        <React.Fragment>
                                            {this.props.urltype == "default"  ? (
                                                <Link
                                                    to={{
                                                        pathname: "/student/default-videos",
                                                    }}
                                                    className="my-0 font-weight-normal text-light mr-auto">
                                                    <i className="fal fa-arrow-left" />
                                                </Link>
                                            ) 
                                            : this.props.urltype == "fdefaultvideo"?(
                                                <Link
                                                    to={{
                                                        pathname: "/student/default-featured-videos",
                                                    }}
                                                    className="my-0 font-weight-normal text-light mr-auto">
                                                    <i className="fal fa-arrow-left" />
                                                </Link>
                                            ):this.props.urltype == "categoryWiseVideo" || this.props.urltype == "notification"?(
                                                <i className="fal fa-arrow-left" onClick={this.props.history.goBack} style={{color:"#fff",cursor:"pointer"}}/>
                                            ): (
                                                    <Link
                                                        to={{
                                                            pathname: "/student/videos",
                                                        }}
                                                        className="my-0 font-weight-normal text-light mr-auto">
                                                        <i className="fal fa-arrow-left" />
                                                    </Link>
                                                )}</React.Fragment>
                                    )}

                            </React.Fragment>

                        )}


                    <div className="my-2 my-md-0 mr-md-5 mx-auto">
                        {/* <Link style={{cursor: "default"}}> */}
                        {this.props.urltype == "default" || this.props.urltype == "fdefaultvideo" ? ("") : (
                            <BrandLogo fill="#ffffff" width="159.501" />
                        )}

                        {/* </Link> */}
                    </div>
                    <Nav className="ml-auto">


                        {this.props.urltype == "default" || this.props.urltype == "fdefaultvideo" ? ("") : (
                            <React.Fragment>
                                <Notification />

                                <NavDropdown id="basic-nav-dropdown2" className="no-arrow" alignRight title={
                                    <div className="profile-img d-flex align-items-center">
                                        {localStorage.getItem("profile_pic") ? (

                                            <Image src={`https://support.rizee.in/files/${localStorage.getItem("profile_pic")}`} roundedCircle alt="profile-img" onError={(e) => { e.target.onerror = null; e.target.src = require('../../../../../images/businessman.png'); }} />
                                        ) : (
                                                <Image src={require('../../../../../images/businessman.png')} roundedCircle alt="profile-img" />
                                            )}

                                        <div className="text mx-2 mt-2">
                                            <div className="profile-name">{Cookies.get("studentusername")}</div>
                                            <small>Exam- {Cookies.get("exam_name")}, Class - {Cookies.get("classid") == "1" ? ("XI") : ("XII")}</small>
                                        </div>
                                    </div>
                                }>
                                    <NavDropdown.Item className="font-weight-bold">{Cookies.get("studentemail")}</NavDropdown.Item>
                                    <NavDropdown.Divider />
                                    {isuserValid.ins_profile_tab == true ? ("") : (<NavDropdown.Item as={Link} to="/student/profile"><i className="far fa-user mr-2" /> My Profile</NavDropdown.Item>)}
                                    {isuserValid.ins_package_tab == true ? ("") : (<NavDropdown.Item as={Link} to="/student/package"><i className="far fa-sack mr-2" /> Package</NavDropdown.Item>)}

                                    <NavDropdown.Item onClick={() => this.setState({ modalShow: true })}><i className="far fa-key mr-2" /> Change Password</NavDropdown.Item>
                                    {isuserValid.ins_feedback_tab == true ? ("") : (<NavDropdown.Item as={Link} to="/student/feedback"><i className="far fa-comment-alt-lines mr-2" /> Feedback</NavDropdown.Item>)}

                                    <NavDropdown.Divider />
                                    <NavDropdown.Item as={Link} onClick={this.logout}><i className="far fa-sign-out mr-2" /> Logout</NavDropdown.Item>
                                </NavDropdown>
                            </React.Fragment>
                        )}

                    </Nav>
                </Container>
                <ChangePassword
                    show={this.state.modalShow}
                    onHide={() => this.setState({ modalShow: false })}
                />
            </Navbar>
        )
    }
}


export default withRouter(compose(

)(VideoNavbar));